import axios from "axios";
import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";

export const STATUSES = Object.freeze({
    IDLE : 'idle',
    ERROR:'error',
    LOADING: 'loading',
});

const getVerifyAndDeleteTrainerSlice = createSlice({
    name: 'VerifyAndDeleteTrainer',
    initialState: {
        data:[],
        status : STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
        .addCase(fetchVerifyAndDeleteTrainer.pending, (state, action) => {
            state.status = STATUSES.LOADING;
        })
        .addCase(fetchVerifyAndDeleteTrainer.fulfilled, (state, action) => {
            state.data = action.payload;
            state.status = STATUSES.IDLE
        }) 
        .addCase(fetchVerifyAndDeleteTrainer.rejected , (state,action) => {
            state.status = STATUSES.ERROR;
        })
    }
});

export const {setVerifyAndDeleteTrainer , setStatus} = getVerifyAndDeleteTrainerSlice.actions;
export default getVerifyAndDeleteTrainerSlice.reducer;

export const fetchVerifyAndDeleteTrainer = createAsyncThunk('/getVerifyAndDeleteTrainer/fetch', async({id}) => {
    const res = await axios.delete(`${window.env.API_URL}/VerifyAndDeleteTrainer/${id}`);
    const VerifyAndDeleteTrainerData = res.data;
    return VerifyAndDeleteTrainerData.data;
})